import { render, staticRenderFns } from "./PromotionCollapse.vue?vue&type=template&id=e6a34aa8&scoped=true"
import script from "./PromotionCollapse.vue?vue&type=script&lang=ts"
export * from "./PromotionCollapse.vue?vue&type=script&lang=ts"
import style0 from "./PromotionCollapse.vue?vue&type=style&index=0&id=e6a34aa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a34aa8",
  null
  
)

export default component.exports